/** Poker専用の共通カード表示。Bridgeの配色とは独立。 */
import type { Card } from '../../games/heads-up-poker';
import { rankLabel, suitClass, suitLabel } from '../../games/heads-up-poker';
import './PokerCard.css';

/** 1 枚のカード描画。 チュートリアル (役一覧) でも再利用するため export。 */
export function PokerCard({
  card,
  faceDown,
  failed,
}: {
  card?: Card | null;
  faceDown?: boolean;
  failed?: boolean;
}) {
  if (failed) {
    // mental poker protocol stuck で復元できなかった hole の表示 (= face down だが「??」 マーク付き)
    return (
      <span
        className="poker-card poker-card-failed"
        aria-label="card unavailable (protocol failed)"
        data-testid="poker-card-failed"
      >
        <span className="poker-card-failed-mark">??</span>
      </span>
    );
  }
  if (!card || faceDown) {
    return (
      <span className="poker-card poker-card-back" aria-label="card back">
        <span className="poker-card-back-pattern" />
      </span>
    );
  }
  const cls = suitClass(card.suit);
  return (
    <span
      className={`poker-card poker-card-${cls}`}
      data-poker-suit={card.suit}
      aria-label={`${rankLabel(card.rank)} of ${suitLabel(card.suit)}`}
    >
      <span className="poker-card-suit">{suitLabel(card.suit)}</span>
      <span className="poker-card-rank">{rankLabel(card.rank)}</span>
    </span>
  );
}


/** 直近ハンド・結果棋譜で使う小型の公開カード。 */
export function PokerInlineCard({ card }: { card: Card }) {
  return <span className={`ph-card ph-card-${suitClass(card.suit)}`} data-poker-suit={card.suit} aria-label={`${rankLabel(card.rank)} of ${suitLabel(card.suit)}`}>
    <span className="ph-card-suit">{suitLabel(card.suit)}</span>{rankLabel(card.rank)}
  </span>;
}
